import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "scrollbar absolute-full-size p-2" }

import {__} from "~/ts/library/Translate";
import SideMenuCard from "~/operatorApplication/vue/dialogs/dialog/sidemenu/SideMenuCard.vue";
import SideMenuInfo from "~/operatorApplication/vue/dialogs/dialog/sidemenu/info/SideMenuInfo.vue";
import {computed} from "vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import OperatorApplicationForwardButtonOperator
    from "~/operatorApplication/vue/dialogs/dialog/sidemenu/OperatorApplicationForwardButtonOperator.vue";
import {OPERATOR_STATUS_OFFLINE} from "~/chat/ts/data/OperatorStatus";

import OperatorGetParamsCrossOperatorGroupOpenApiModel = OperatorApplicationApi.OperatorGetParamsCrossOperatorGroupOpenApiModel;
import OperatorGetParamsOperatorOpenApiModel = OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel;

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "SideMenuCrossOperatorsGroupChatInfoTab"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    group: {}
  },
  setup(__props: any) {

let props = __props;


let operators = computed(() => {
    return props.group.operatorLogins
        .map(login => OperatorAccountStore.operatorsDictionary.value[login])
        .filter(operator => !!operator)
        .sort((a, b) => {
            if (a.statusId === b.statusId) {
                return a.fio < b.fio ? -1 : 1;
            } else {
                if (a.statusId == OPERATOR_STATUS_OFFLINE) {
                    return 1;
                } else {
                    return -1;
                }
            }
        });
});

function onOperatorClick(operator: OperatorGetParamsOperatorOpenApiModel) {
    if (operator.chatId) {
        if (operator.login != OperatorAccountStore.operator.value.login) {
            OperatorApplicationBuddyList.openClientByUsername(operator.chatId);
        }
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SideMenuCard, { class: "info" }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(__)('Операторы')), 1)
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(operators), (operator) => {
          return (_openBlock(), _createBlock(SideMenuInfo, {
            class: "align-items-center",
            "click-listening": "",
            bordered: false,
            compact: "",
            onClick: ($event: any) => (onOperatorClick(operator))
          }, {
            default: _withCtx(() => [
              _createVNode(OperatorApplicationForwardButtonOperator, { operator: operator }, null, 8, ["operator"])
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 256))
      ]),
      _: 1
    })
  ]))
}
}

})